// extracted by mini-css-extract-plugin
export default {"projekte-container":"projekte_projekte-container__KjNn+","projekte-title":"projekte_projekte-title__lhRsj","projekte-img":"projekte_projekte-img__awnhl"};